// extracted by mini-css-extract-plugin
module.exports = {"label":"a10a3f92e9--label--on1E5","container":"a10a3f92e9--container--ZPpxg","description":"a10a3f92e9--description--QoyxP","price_bar":"a10a3f92e9--price_bar--_rlY2"};